<template>
  <b-form-group>
    <label class="mr-2">
      {{ label }}
      <small class="text-muted" :title="trans('days_before_or_after_about')" v-b-tooltip.hover>
        <i class="fa fa-fw fa-info-circle"></i>
      </small>
    </label>
    <b-row>
      <b-col class="pr-0">
        <b-form-input type="number" v-model="days" min="0" @input="onChange"></b-form-input>
      </b-col>
      <b-col>
        <b-form-radio-group button-variant="outline-primary" v-model="multiplier" :options="options" buttons @input="onChange"></b-form-radio-group>
      </b-col>
    </b-row>
  </b-form-group>
</template>
<script>
  export default {
    props: {
      value: Number,
      onlyAfter: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        default: trans('days_before_or_after'),
      },
    },
    data() {
      return {
        trans: trans,
        days: Math.abs(this.value),
        multiplier: this.value < 0 || this.onlyAfter ? -1 : 1,
        options: [{
          value: 1,
          text: trans('before'),
          disabled: this.onlyAfter,
        }, {
          value: -1,
          text: trans('after'),
        }],
      }
    },
    methods: {
      onChange() {
        this.$emit('input', this.days * this.multiplier)
      },
    },
    mounted() {
      window.daysBeforeComponent = this
    }
  }
</script>